import store from "@/redux/store";

import React, { useState } from "react";

//import {showLoader,hideLoader} from "actions/types";
import { connect, useSelector, useDispatch} from "react-redux";
import { Detail } from "@/views/customer/Detail";
import UserAPI from "@/api/UserAPI";
import { loadCustomer, addCustomer, addCompany, unsetSelected } from '@/reducers/Customer'
import { alert, info,success, error } from '@/reducers/Modal'
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";

class CustomerDetailController extends React.Component {

  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };
    
  }

    async componentDidMount() {
        const { dispatch, selectedId } = this.props;
        //if(isLoggedIn && user.id == 0) {
        try {
            if(selectedId) {
                await dispatch(loadCustomer(selectedId));
            } else {
                await dispatch(unsetSelected());
            }
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }
    //  }
    }


    onSaveHandler = async (data) => {
        const { dispatch } = this.props;


console.debug('koen',data.getData());

     try {

       await dispatch(addCompany(data.getData()));
//        await dispatch(addCustomer(data.getData()));


      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }
        if(!this.props.customerReducer.error) {
            dispatch( success({"header": "Opslaan gegevens", "description": "De gegevens zijn met succes opgeslagen!"}) );
            this.props.navigate("/customers/");
       }


    }

  render() {
      const {customerReducer} = this.props;
      const {selected, interests} = customerReducer;
      
    return (
        <>
        {selected &&
      <Detail onSaveHandler={this.onSaveHandler} {...this.props} selected={selected} data={selected} interests={interests}/>
      }
      </>
    );
  }
}

const CustomerDetailControllerInit = (props) => {
    const postStatus = useSelector(state => props.customerReducer)
    const {customerReducer} = props;
    let { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

  return (
    <CustomerDetailController
      {...props}
      state={postStatus}
      selectedId={id}
      customerReducer={customerReducer}
      navigate={navigate}
      location={location}
    />
  );
};

function mapStateToProps(state) {
    const {CustomerReducer} = state;
  return {
      customerReducer: CustomerReducer
  };
}

export default connect(mapStateToProps)(CustomerDetailControllerInit);
